import React, { FC, useMemo, useState } from 'react';
import translate from '@translate';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import Button from 'src/components/Button';
import JsonCodeViewer from 'src/components/JsonCodeViewer';
import { WebhookDeliveryRowType } from 'src/types/webhookDeliveriesGrid';
import { shouldShowWebhookPayload, stringifyPayload } from '../WebhookRecordsListContainer/functions';

type PayloadSectionProps = {
    method: string;
    payload: WebhookDeliveryRowType['PAYLOAD'];
};

const PayloadSection: FC<PayloadSectionProps> = (props) => {
    const { method, payload } = props;
    const [expanded, setExpanded] = useState(false);
    const payloadRaw = useMemo(() => stringifyPayload(payload), [payload]);

    if (!shouldShowWebhookPayload(method, payload)) {
        return null;
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Button
                variant="outlined"
                onClick={() => setExpanded((current) => !current)}
                data-testid="webhook-record-detail-payload-toggle"
            >
                {expanded
                    ? translate('webhookRecordDetail.payload.hide')
                    : translate('webhookRecordDetail.payload.show')}
            </Button>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Box sx={{ mt: 2 }}>
                    <JsonCodeViewer
                        value={payloadRaw}
                        label={translate('webhookRecords.table.payload')}
                        helperText={translate('webhookRecordDetail.payload.formattedHint')}
                        testId="webhook-record-detail-payload"
                        minHeight={240}
                    />
                </Box>
            </Collapse>
        </Box>
    );
};

export default PayloadSection;
